import React from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { AiOutlineClose } from 'react-icons/ai';
import '../scss/invoice-success-modal.scss';

interface InvoiceSuccessModalProps {
  show: boolean;
  onClose: () => void;
  isEditMode?: boolean;
}

export const InvoiceSuccessModal: React.FC<InvoiceSuccessModalProps> = ({
  show,
  onClose,
  isEditMode = false,
}) => {
  const { t } = useTranslation();
  return (
    <Modal 
      show={show} 
      onHide={onClose} 
      centered 
      className="invoice-success-modal"
      backdrop="static"
    >
      <Modal.Header>
        <AiOutlineClose
          className="close-icon"
          size={24}
          onClick={onClose}
        />
      </Modal.Header>

      <Modal.Body>
        <div className="success-content">
         

          {/* Success Message */}
          <h2 className="success-title">
            {isEditMode ? t('EDIT_REQUEST_SENT_SUCCESSFULLY') : t('INVOICE_SENT_SUCCESSFULLY')}
          </h2>

          {/* <p className="success-description">
            {isEditMode 
              ? t('EDIT_REQUEST_SENT_SUCCESSFULLY_MESSAGE')
              : t('INVOICE_SENT_SUCCESSFULLY_MESSAGE')}
          </p> */}

           {/* Share Icon */}
          <div className="icon-container">
            <img 
              src="/assets/svg/Share-icon-invoice-create-sucessfuly-popup.svg" 
              alt="Share Icon" 
              className="share-icon"
            />
          </div>

          {/* Check Icon */}
          <div className="check-icon-wrapper">
            <img 
              src="/assets/svg/Check-icon-invoice-create-sucessfully-popup.svg" 
              alt="Check Icon" 
              className="check-icon"
            />
          </div>

          {/* Done Button */}
          <button
            type="button"
            className="done-btn"
            onClick={onClose}
          >
            {t('DONE')}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default InvoiceSuccessModal;
